import classNames from 'classnames'
import type { ComponentType } from 'react'

import Link from 'content-components/_Primatives/Link'
import style from './style.scss'

type Props = {
  className?: string
  url?: string
  onClick?: () => void
  Icon: ComponentType
  text?: string
}

function DateNavigationArrowButton({
  className,
  url,
  onClick,
  Icon,
  text,
}: Props) {
  return (
    <div className={classNames(style.wrapper, className)}>
      {url && !onClick && (
        <Link className={style.link} url={url} aria-label={text}>
          <Icon />
        </Link>
      )}
      {onClick && (
        <button className={style.link} onClick={onClick} aria-label={text}>
          <Icon />
        </button>
      )}
    </div>
  )
}

export default DateNavigationArrowButton
